// extracted by mini-css-extract-plugin
export default {"decorative":"decorative__kBGDx","confidenceField":"confidenceField__kpwkN","floatRight":"floatRight__roV29"};